import { render } from "./EsSysIcon.vue?vue&type=template&id=652faf64&scoped=true"
import script from "./EsSysIcon.vue?vue&type=script&lang=js"
export * from "./EsSysIcon.vue?vue&type=script&lang=js"

import "./EsSysIcon.vue?vue&type=style&index=0&id=652faf64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-652faf64"]])

export default __exports__